import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let default_1 = class extends Vue {
    back() {
        if (this.$route.query.noGoBack) {
            this.$router.push({ path: '/' });
        }
        else {
            this.$router.go(-1);
        }
    }
};
default_1 = tslib_1.__decorate([
    Component({
        name: 'Page404',
    })
], default_1);
export default default_1;
